import axiosInstance from './axios/index';
import { InvoiceManagementApi } from '../api-client/generated';

// Public (no auth) — token-based invoice view
const getInvoiceByToken = async (tokenParam: any) => {
  const apiCaller = new InvoiceManagementApi();
  const response = await apiCaller.invoiceGetInvoiceByToken({
    token: tokenParam.token
  });
  return response.data;
};

// Authenticated — uses axiosInstance (includes JWT from store)
const getInvoicesById = async (id: string) => {
  if (!id) return null;
  const response = await axiosInstance.get(`/invoices/${id}`);
  return response.data;
};

const getInvoicesList = async (
  projectId: string,
  status: 'PENDING' | 'OVERDUE' | 'PAID' | undefined
) => {
  try {
    const response = await axiosInstance.get('/invoices', {
      params: { projectId, ...(status && { status }) }
    });
    return response.data;
  } catch {
    return [];
  }
};

const updateInvoiceByStatus = async (id: string, status: string) => {
  if (!id || !status) return null;
  const statusMap: Record<string, string> = {
    overdue: 'OVERDUE',
    paid: 'PAID',
    pending: 'PENDING'
  };
  const mapped = statusMap[status.toLowerCase()];
  if (!mapped) throw new Error(`status not valid: ${status}`);
  const response = await axiosInstance.patch(`/invoices/${id}/status`, {
    status: mapped
  });
  return response.status === 200 ? id : null;
};

const resendInvoiceById = async (id: string) => {
  if (!id) return null;
  const response = await axiosInstance.post(`/invoices/${id}/resend`);
  return response.data;
};

const getClientInvoicesFiltered = async (params: any) => {
  const { id: clientId, month: m, year } = params;
  const month = m === 0 ? undefined : m;
  const response = await axiosInstance.get(
    `/invoices/client-invoices-filtered/${clientId}`,
    {
      params: {
        month: month !== undefined && month < 10 ? `0${month}` : month,
        year
      }
    }
  );
  return response.data;
};

export default {
  getClientInvoicesFiltered,
  getInvoiceByToken,
  getInvoicesById,
  getInvoicesList,
  resendInvoiceById,
  updateInvoiceByStatus
};
